module.exports = __webpack_public_path__ + "img/share.53d30bea.png";